<template>
  <form method="post" @submit.prevent="send">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title is-centered">
          {{ formTitle }}
        </p>
      </header>
      <section class="modal-card-body">
        <form-wrapper :validator="$v.form">
          <form-group
            horizontal
            name="product_name"
            attribute="attributes.product_name"
            :label="$t('attributes.product_name')"
          >
            {{ productName }}
          </form-group>
          <form-group
            horizontal
            name="product_code"
            attribute="attributes.product_code"
            :label="$t('attributes.product_code')"
          >
            {{ form.product_code }}
          </form-group>
          <form-group
            horizontal
            name="sort"
            attribute="attributes.sort"
            :label="$t('attributes.sort')"
          >
            <b-select v-model="form.sort" name="sort">
              <option
                v-for="option in sortOptions"
                :key="option"
                :value="option"
              >
                {{ option }}
              </option>
            </b-select>
          </form-group>

          <form-group
            horizontal
            name="week"
            required
            attribute="attributes.week"
            :label="$t('attributes.week')"
          >
            <b-input
              v-model="form.week"
              name="week"
              :placeholder="$t('message.please_input') + $t('attributes.week')"
              expanded
            >
            </b-input>
          </form-group>
          <form-group
            horizontal
            name="direction"
            required
            attribute="attributes.direction"
            :label="$t('attributes.direction')"
          >
            <b-input
              v-model="form.direction"
              name="direction"
              :placeholder="
                $t('message.please_input') + $t('attributes.direction')
              "
              expanded
            >
            </b-input>
          </form-group>
          <form-group
            horizontal
            name="arrive_time"
            attribute="attributes.arrive_time"
            :label="$t('attributes.arrive_time')"
          >
            <b-input
              v-model="form.arrive_time"
              name="arrive_time"
              :placeholder="
                $t('message.please_input') + $t('attributes.arrive_time')
              "
              expanded
            >
            </b-input>
          </form-group>
          <form-group
            horizontal
            name="checkin_time"
            attribute="attributes.checkin_time"
            :label="$t('attributes.checkin_time')"
          >
            <b-input
              v-model="form.checkin_time"
              name="checkin_time"
              :placeholder="
                $t('message.please_input') + $t('attributes.checkin_time')
              "
              expanded
            >
            </b-input>
          </form-group>
          <form-group
            horizontal
            name="gate_close_time"
            attribute="attributes.gate_close_time"
            :label="$t('attributes.gate_close_time')"
          >
            <b-input
              v-model="form.gate_close_time"
              name="gate_close_time"
              :placeholder="
                $t('message.please_input') + $t('attributes.gate_close_time')
              "
              expanded
            >
            </b-input>
          </form-group>
          <form-group
            horizontal
            name="departure_time"
            attribute="attributes.departure_time"
            :label="$t('attributes.departure_time')"
          >
            <b-input
              v-model="form.departure_time"
              name="departure_time"
              :placeholder="
                $t('message.please_input') + $t('attributes.departure_time')
              "
              expanded
            >
            </b-input>
          </form-group>
        </form-wrapper>
      </section>
      <footer class="modal-card-foot">
        <b-button class="is-fullwidth" @click="$parent.close()">
          {{ $t('attributes.close') }}
        </b-button>
        <b-button
          type="is-primary"
          class="is-fullwidth"
          :loading="sending"
          native-type="submit"
        >
          {{ submitTitle }}
        </b-button>
      </footer>
    </div>
  </form>
</template>

<script>
import { maxLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'VoyageForm',
  props: {
    detail: {
      required: false,
      type: Object
    },
    sending: Boolean,
    productName: String,
    isCreate: Boolean
  },
  data() {
    return {
      formTitle:
        this.$t(this.isCreate ? 'attributes.add' : 'attributes.modify') +
        this.$t('attributes.voyage'),
      submitTitle: this.$t(
        this.isCreate ? 'attributes.add' : 'attributes.update'
      ),
      sortOptions: 20,
      form: this.extractFormValues(this.detail),
      loading: false
    }
  },
  validations: {
    form: {
      id: {},
      product_code: { required, maxLength: maxLength(9) },
      week: { required, maxLength: maxLength(50) },
      direction: { required, maxLength: maxLength(50) },
      arrive_time: { maxLength: maxLength(50) },
      departure_time: { maxLength: maxLength(50) },
      checkin_time: { maxLength: maxLength(50) },
      gate_close_time: { maxLength: maxLength(50) },
      area_code: {},
      sort: {}
    }
  },
  methods: {
    extractFormValues(data) {
      return {
        id: data.id,
        product_code: data.product_code,
        week: data.week,
        direction: data.direction,
        arrive_time: data.arrive_time,
        departure_time: data.departure_time,
        checkin_time: data.checkin_time,
        gate_close_time: data.gate_close_time,
        area_code: data.area_code,
        sort: data.sort
      }
    },
    async send() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      this.$emit('onSend', this.form)
    }
  }
}
</script>

<style scoped></style>
